import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=aee48cc0&scoped=true&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee48cc0",
  null
  
)

export default component.exports